module.exports = __webpack_public_path__ + "static/use3-bac42498123f412f5ab6db53aa9b5e0f.png";